import React from 'react';
import Navbar from '../Navbar';

function Home() {
  return (
    <Navbar/>
  )
}

export default Home